
export const setPlacesSearchMarker = (vueInstance, val) => {
    let self = vueInstance;

    if(self.placesSearchType == 'latlng' && val) {
        let parts = val.split(',');
        if(parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) {
            return;
        }
        let lat = parts[0];
        let lng = parts[1];
        let coords = new google.maps.LatLng(lat, lng);
        createPlacesMarker(self, coords, val);
        self.googleMapsObj.setZoom(14);
        self.googleMapsObj.panTo(coords);        
    }
    else if(self.placesSearchType == 'places' && val && typeof val == 'object') {
        let request = {
            placeId: self.placesSearchSelection.value,
            fields: ['name', 'geometry']
        }
        let callback = function(placeResult) {
            createPlacesMarker(self, placeResult.geometry.location, placeResult.name);
            self.googleMapsObj.setZoom(14);
            self.googleMapsObj.panTo(placeResult.geometry.location);
        };
        self.placesService.getDetails(request, callback);
    }
};


export const changePlacesSearchType = (vueInstance, type) => {
    let self = vueInstance;

    self.placesSearchValue = "";
    self.placesSearchResults = [];
    self.placesSearchType = type;
};

export const handlePlacesSearchValue = (vueInstance, val) => {
    let self = vueInstance;

    if(self.placesSearchType == 'latlng') {
        return;
    }
    if(!val || val.length < 4) {
        // too short
        return;
    }
    self.placesSearchLoading = true;
    placesAutoCompleteFunc(self, val).then(results => {
        let searchResults = [];
        for(let result of results.predictions) {
            searchResults.push({
                text: result.structured_formatting.main_text,
                title: result.structured_formatting.main_text,
                subtitle: result.structured_formatting.secondary_text,
                icon: result.types[0],
                value: result.place_id
            });
        }
        self.placesSearchResults = searchResults;
        self.placesSearchLoading = false;
    });
};


export const placesAutoCompleteFunc = (vueInstance, searchVal) => {
    let self = vueInstance;

    let request = {
        input: searchVal,
        bounds: self.googleMapsObj.getBounds(),
        offset: 4,
    };
    return self.placesAutoCompleteService.getPlacePredictions(request);
};



export const createPlacesMarker = (vueInstance, position, name) => {
    let self = vueInstance;

    let mapElement = new self.AdvancedMarkerElement({
        map: self.googleMapsObj,
        position: position,
        title: name,
        gmpClickable: false,
        gmpDraggable: false,
    });
    mapElement.addEventListener('contextmenu', (e) => {
        mapElement.remove();
        self.placesMarkers.splice(self.placesMarkers.findIndex(marker => marker === mapElement), 1);
    });
    self.placesMarkers.push({
        name: name,
        position: position,
        mapElement: mapElement
    });
};

